import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { UserPermInquiryStates } from '../states';
import { UserPermInquiryState } from '../states/user-permissions-inquiry.states';

export const userPermInquiryFeatureKey = 'userPermInquiry';

export const selectUserPermFeature = createFeatureSelector<UserPermInquiryState>(userPermInquiryFeatureKey);

export const selectUserPermInquiry = (state: PermissionStates) => state.permissions.userPermInquiry.userPermissionTargets;
